import {formatMoney} from "../utils/formatters";
import currencyFormatter from "currency-formatter";

export function totalsFill(data) {
  if (data.no_discount_subtotal != null) {
    $('[data-order-field="no_discount_subtotal"]').text(formatMoney(data.no_discount_subtotal));
  }
  if (data.all_order_discount_total != null) {
    $('[data-order-field="all_order_discount_total"]').text(formatMoney(data.all_order_discount_total));
  }
  if (data.tax_collectible != null) {
    $('[data-order-field="tax"]').text(formatMoney(data.tax_collectible));
  }
  if (data.shipping_collectible != null) {
    $('[data-order-field="shipping"]').text(data.shipping_collectible !== null ? formatMoney(data.shipping_collectible) : 'Shipping Quote will be Emailed');
  }
  if (data.total != null) {
    $('[data-order-field="total"]').text(formatMoney(data.total));
  }
  if (data.shipping_address != null) {
    $('[data-order-field="shipping-address"]').text(`${data.shipping_address.city}, ${data.shipping_address.subdivision}, ${data.shipping_address.country.alpha3} via ${data.shipping_method.name}`);
  }
  if (data.coupon_code != null) {
    $('[data-order-field="coupon_code"]').text(data.coupon_code);

    if (data.coupon_code) {
      $('[data-order-row="coupon_code"]').removeClass("d-none");
    } else {
      $('[data-order-row="coupon_code"]').addClass("d-none");
    }
  }
  if (data.all_order_discount_total != null) {
    $('[data-order-field="discount"]').text(formatMoney(data.all_order_discount_total_negative));

    if (data.all_order_discount_total_negative.amount !== undefined && parseFloat(data.all_order_discount_total_negative.amount) < 0) {
      $('[data-order-row="discount"]').removeClass("d-none");
    } else {
      $('[data-order-row="discount"]').addClass("d-none");
    }
  }

  data.items.forEach(item => {
    $(`[data-order-item-id="${item.id}"] [data-order-item-field="subtotal"]`).text(formatMoney(item.subtotal)).removeClass('text-muted');
  });
  return data;
};
